/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  FooterService,
  IFooterMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  UpdateProfileService,
  IUpdateProfileMethods,
  CreateProfileService,
  ICreateProfileMethods,
  GetProfileService,
  IGetProfileMethods,
  IGetFormDataMethods,
  GetFormDataService,
  IGetFormCityMethods,
  GetFormCityService,
  GetCitiesService,
  IGetCitiesMethods,
  IGetIndustryTypeListMethods,
  GetIndustryTypeListService,
  DocRejectedUpdateProfileService,
  IDocRejectUpdateProfileMethods,
  createroeCompanySetupService,
  IcreateroeCompanySetupMethods,
  IreinviteDirectorMethods,
  reinviteDirectorService,
  IsOrgNameExistService,
  IIsOrgNameExistMethods
} from './plugins';

export type MyProfileAgent = IHeaderMethods &
  IFooterMethods &
  IStaticPageContentMethods &
  IUpdateProfileMethods &
  ICreateProfileMethods &
  IGetProfileMethods &
  ICreateProfileMethods &
  IGetFormDataMethods &
  IGetFormCityMethods &
  IGetCitiesMethods &
  IGetIndustryTypeListMethods &
  IDocRejectUpdateProfileMethods &
  IreinviteDirectorMethods &
  IcreateroeCompanySetupMethods &
  IIsOrgNameExistMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new FooterService(),
    new StaticPageContentService(),
    new UpdateProfileService(),
    new CreateProfileService(),
    new GetProfileService(),
    new GetFormDataService(),
    new GetFormCityService(),
    new GetCitiesService(),
    new GetIndustryTypeListService(),
    new DocRejectedUpdateProfileService(),
    new createroeCompanySetupService(),
    new reinviteDirectorService(),
    new IsOrgNameExistService(),
  ];
};

export const getAgent = () => {
  return createAgent<MyProfileAgent>({
    plugins: getPlugins(),
  });
};
